export const Colors = {
    compare: '#ffc107',
    sorted: '#aed581',
    vertex: '#e5e5e5',
    stroke: '#424242',
    enqueue: '#2196f3',
    rejected: '#c5c5c5',
    visited: '#ff9800',
};
